import { default as locale } from 'date-fns/locale/pt-BR'
import parseISO from 'date-fns/parseISO'
import isToday from 'date-fns/isToday'
import isYesterday from 'date-fns/isYesterday'
import format from 'date-fns/format'


/**
 * @param {number} amount
 * @returns {string}
 */
const absoluteAmount = (amount) => {
  return Math
    .abs(amount)
    .toFixed(2)
    .toString()
    .replace('.', ',')
}

const parseDate = (statementDate) => {
  const date = parseISO(statementDate)

  if (isToday(date)) {
    return 'hoje'
  } else if (isYesterday(date)) {
    return 'ontem'
  } else {
    return format(date, 'dd MMM', { locale })
  }
}

const parseTime = (statementDate) => {
  const date = parseISO(statementDate)

  return format(date, 'hh:mm', { locale })
}

/**
 * @param {ApiWalletStatement} data
 * @returns {Statement}
 */
export const parseStatement = (data) => ({
  operationType: data.operation,
  originType: 0,
  date: parseDate(data.dateCreated),
  time: parseTime(data.dateCreated),
  amount: data.amount,
  amountFormat: data.amountFormat,
  amountAbsolute: absoluteAmount(data.amount),
  description: data.description,
})

export default {
  parseStatement
}